import httpClient from "../../../../../shared/api/httpClient";
import { qs } from "../../../../../shared/api/qs";
import { downloadBlob, getFilenameFromContentDisposition } from "../../../../../shared/utils/downloadBlob";

export function getSalesImports({
  page = 1,
  limit = 20,
  dateFrom,
  dateTo,
  signal,
} = {}) {
  const query = qs({ page, limit, dateFrom, dateTo });
  return httpClient.get(`/stock/sales-imports${query}`, { signal });
}

export function getSalesImport(importId, { signal } = {}) {
  return httpClient.get(`/stock/sales-imports/${importId}`, { signal });
}

export async function downloadSalesImportFile(importId, { signal } = {}) {
  const response = await httpClient.getBlobWithHeaders(
    `/stock/sales-imports/${importId}/file`,
    { signal, headers: { Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" } }
  );
  const fileName = getFilenameFromContentDisposition(response.headers?.get?.("content-disposition")) || `ventas-importadas-${importId}.xlsx`;
  downloadBlob(response.data, fileName);
  return { fileName };
}

export function createSalesImportDraft(file, { signal } = {}) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient.post("/stock/sales-imports/drafts", formData, { signal });
}

export function cancelSalesImportDraft(draftId, { signal } = {}) {
  return httpClient.delete(`/stock/sales-imports/drafts/${draftId}`, { signal });
}

export function getSalesImportProductOptions({ search, limit = 50, signal } = {}) {
  const query = qs({ search, limit });
  return httpClient.get(`/stock/sales-imports/sale-product-options${query}`, { signal });
}

export function getSalesImportMatching(draftId, { signal } = {}) {
  return httpClient.post(`/stock/sales-imports/drafts/${draftId}/matching`, {}, { signal });
}

export function saveSalesImportResolutions(
  draftId,
  { expectedVersion, resolutions },
  { signal } = {}
) {
  return httpClient.put(
    `/stock/sales-imports/drafts/${draftId}/resolutions`,
    { expectedVersion, resolutions },
    { signal }
  );
}

export function recalculateSalesImportPreview(draftId, expectedVersion, { signal } = {}) {
  return httpClient.post(
    `/stock/sales-imports/drafts/${draftId}/preview`,
    { expectedVersion },
    { signal }
  );
}

export function confirmSalesImportRegularizations(
  draftId,
  expectedVersion,
  { signal } = {}
) {
  return httpClient.post(
    `/stock/sales-imports/drafts/${draftId}/regularizations/confirm`,
    { expectedVersion },
    { signal }
  );
}

export function getSalesImportTreasuryPeriods({ signal } = {}) {
  return httpClient.get("/treasury/periods?status=DRAFT", { signal });
}

export function getSalesImportTreasuryCategories({ signal } = {}) {
  return httpClient.get("/treasury/movement-categories?is_active=true", { signal });
}

export function getSalesImportTreasuryAccounts({ signal } = {}) {
  return httpClient.get("/treasury/accounts", { signal });
}

export function getSalesImportTreasuryPeriodBalances(periodId, { signal } = {}) {
  return httpClient.get(`/treasury/periods/${periodId}/balances`, { signal });
}

export function saveSalesImportTreasury(
  draftId,
  { expectedVersion, periodId, categoryId, allocations },
  { signal } = {}
) {
  return httpClient.put(
    `/stock/sales-imports/drafts/${draftId}/treasury`,
    { expectedVersion, periodId, categoryId, allocations },
    { signal }
  );
}

export function integrateSalesImport(
  draftId,
  { expectedVersion, requestId },
  { signal } = {}
) {
  return httpClient.post(
    `/stock/sales-imports/drafts/${draftId}/integrate`,
    { expectedVersion, requestId },
    { signal }
  );
}
